// removed by extract-text-webpack-plugin
module.exports = {"Quote":"src-components-Destination-Quote----Quote-module---Quote---17TOp","Quote__Wrapper":"src-components-Destination-Quote----Quote-module---Quote__Wrapper---Lfl2A","Quote__Details":"src-components-Destination-Quote----Quote-module---Quote__Details---3MG5L","Quote__Text":"src-components-Destination-Quote----Quote-module---Quote__Text---20Z21"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Destination/Quote/Quote.module.scss
// module id = 166
// module chunks = 116453730430729 128375257210180 243680507791214